/* 404: any unknown path. */
import { House } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Button } from '@/components/ui'
import { useDocumentTitle } from '@/lib/useDocumentTitle'
import { SystemFrame } from './SystemFrame'

export function NotFoundPage() {
  const { t } = useTranslation('errors')
  useDocumentTitle(t('notFound.title'))
  return (
    <SystemFrame>
      <p className="font-mono text-13 font-medium tracking-wider text-brand-600">{t('notFound.code')}</p>
      <h1 className="mt-3 display text-28 sm:text-32">{t('notFound.title')}</h1>
      <p className="mt-3 max-w-md text-15 leading-7 text-muted">{t('notFound.body')}</p>
      <Button asChild className="mt-8" icon={<House />}>
        <Link to="/">{t('notFound.home')}</Link>
      </Button>
    </SystemFrame>
  )
}

export default NotFoundPage
